import React from 'react';
import { motion } from 'framer-motion';
import useClickOutside from '../../hooks/useClickOutside';

interface FilterDropdownProps {
  type: string;
  label: string;
  options: string[];
  selectedValue: string;
  onSelect: (value: string) => void;
  isOpen: boolean;
  onToggle: () => void;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  type,
  label,
  options,
  selectedValue,
  onSelect,
  isOpen,
  onToggle
}) => {
  const dropdownRef = useClickOutside<HTMLDivElement>(() => {
    if (isOpen) {
      onToggle(); // Fecha se estiver aberto
    }
  });

  return (
    <div className="relative" ref={dropdownRef}>
      <motion.button
        onClick={onToggle}
        className="flex h-9 shrink-0 items-center justify-center gap-x-2 rounded-lg bg-gray-100 dark:bg-background-dark-elevated2 pl-4 pr-2 hover:bg-gray-200 dark:hover:bg-background-dark-elevated3 transition-colors border border-transparent dark:border-primary-darkMode"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <p className="text-[#181411] dark:text-white text-sm font-medium leading-normal">
          {selectedValue || label}
        </p>
        <motion.span
          className="material-symbols-outlined text-lg"
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          expand_more
        </motion.span>
      </motion.button>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.95 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className="absolute top-full left-0 mt-2 w-48 bg-white dark:bg-background-dark-elevated rounded-lg shadow-lg border border-gray-200 dark:border-primary-darkMode z-50"
        >
          <div className="p-2">
            {options.map((option, index) => (
              <motion.button
                key={option}
                onClick={() => {
                  onSelect(option);
                  onToggle(); // Fecha após a seleção
                }}
                className={`w-full text-left px-3 py-2 text-sm rounded-md transition-colors ${selectedValue === option
                    ? 'bg-primary text-white'
                    : 'text-gray-700 dark:text-gray-300 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-background-dark-elevated3'
                  }`}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ x: 5 }}
              >
                {option}
              </motion.button>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default FilterDropdown;